import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  connect() {
    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    this.openAuthModal();
  }

  openAuthModal() {
    // Create a temporary link element that targets the modal turbo frame
    const tempLink = document.createElement("a");
    tempLink.href = "/auth";
    tempLink.setAttribute("data-turbo-frame", "modal_content");
    tempLink.style.display = "none";

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
}
